const UserAgent = navigator.userAgent.toLowerCase();

export const isMobile = /mobile/.test(UserAgent);

export const isPC = window.innerWidth > 960;
